import { APP_NAME } from "./api";

// import LOGO_SAWIT_WEB_VERTICAL from "../assets/icons/vertical.png";
// import LOGO_SAWIT_WEB_HORIZONTAL from "../assets/icons/horizontal.png";
import LOGO_SEMAI_KEBUN_VERTICAL from "../assets/icons/logo-semai-kebun-v.png";
import LOGO_SEMAI_KEBUN_HORIZONTAL from "../assets/icons/logo-semai-kebun-h.png";

import LOGO_SAWIT_WEB_VERTICAL from "../assets/icons/logo-semaiPRO-v.png";
import LOGO_SAWIT_WEB_HORIZONTAL from "../assets/icons/logo-semaiPRO-h.png";

import DEFAULT_FAVICON from "../assets/favicon/favicon-semaiPro.ico";

export const themes = {
  "semai-kebun": {
    primary: "#7C0711",
    primaryHover: "#5a050c",
    secondary: "#303036",
    accent: "rgba(124, 7, 17, 0.2)",
    accentHover: "rgba(124, 7, 17, 0.3)",
    logoVertical: LOGO_SEMAI_KEBUN_VERTICAL,
    logoHorizontal: LOGO_SEMAI_KEBUN_HORIZONTAL,
    favicon: DEFAULT_FAVICON,
    title: "Semai Kebun",
    defaultRoute: "/riwayat-panen",
  },
  // ini yg tdnya warna kuning
  "sawit-web": {
    primary: "#7C0711",
    primaryHover: "#5a050c",
    secondary: "#303036",
    accent: "rgba(124, 7, 17, 0.2)",
    accentHover: "rgba(124, 7, 17, 0.3)",
    logoVertical: LOGO_SAWIT_WEB_VERTICAL,
    logoHorizontal: LOGO_SAWIT_WEB_HORIZONTAL,
    favicon: DEFAULT_FAVICON,
    title: "semaiPRO",
    defaultRoute: "/produksi-kebun",
  },
};

export const getTheme = () => themes[APP_NAME] || themes["sawit-web"];
